// deleteStaffHandler.js
import Swal from "sweetalert2";
import axios from "axios";

export const DeleteStaff = async (staffId, refreshList) => {
  try {
    // Step 1 — Ask for confirmation
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This staff record will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirm.isConfirmed) return;

    // Step 2 — Call BACKEND API
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/staff/delete-staff/${staffId}`
    );

    // Step 3 — Success alert
    await Swal.fire({
      title: "Deleted!",
      text: response.data.message || "Staff deleted successfully",
      icon: "success",
      timer: 1500,
      showConfirmButton: false,
    });

    // Step 4 — Refresh the table or remove row
    if (refreshList) refreshList();
  } catch (error) {
    Swal.fire({
      title: "Error!",
      text: error.response?.data?.message || "Failed to delete staff",
      icon: "error",
    });
  }
};
